/* eslint-disable no-undef */
export default {
	name: "customer-discount-group-products-modal",
	props: ["heading", "modalId", "showModal", "customerDiscountGroupId"],
	emits: ["okClicked"],
	data() {
		return {
			products: [],
			productsHeadings:[
				{
					text: "#",
					field: "productId"
				},
				{
					text: "Product Name",
					field: "productName"
				},
				{
					text: "Price",
					field: "price"
				}
			],
			customerSearchQuery: null,
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getCustomerDiscountGroupProducts() {
			this.products = [
				{
					customerDiscountGroupProductId: 1,
					customerDiscountGroupId: 1,
					productId: 1,
					productName: "Diesel 50ppm",
					productCode: "D50",
					productDescription: "Diesel 50ppm",
					price: "R15.00",
					isActive: true
				},
			];
			this.products = dataTableHelper.castFieldValues(this.products);
		},
		onFilterSearchClicked(){
			
		},
		onModalCloseClick() {
			this.$emit("okClicked", true);
		},
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		customerDiscountGroupId:{
			handler: function () {
				this.getCustomerDiscountGroupProducts();
			},
			immediate: true,
			deep: true
		}
	}
};
